import React, { useState, useRef, useEffect } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default function ReusableSelect({
  options = [],
  placeholder = "Select...",
  width = "100%",
  value = null,
  onChange,
  isMulti = false,
  onClose = null,
  enhancedMenu = false,
}) {
  const selectRef = useRef();
  const [menuWidth, setMenuWidth] = useState(200);
  const [tempSelection, setTempSelection] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const MenuProps = {
    PaperProps: {
      sx: {
        display: "none",
      },
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: menuWidth,
        maxWidth: 300,
      },
    },
    MenuListProps: {
      sx: {
        "& .MuiMenuItem-root": {
          fontSize: "12px",
          textWrap: "auto",
        },
        "& .MuiListItemText-root": {
          "& .MuiTypography-root": { fontSize: "12px" },
        },
      },
    },
  };

  // const selectedValues = isMulti
  //   ? (value || []).map((v) => v.value)
  //   : value?.value || "";

  const selectedValues = isMulti
  ? (Array.isArray(value) ? value : []).map((v) => v.value)
  : value?.value || "";

  const handleChange = (e) => {
    const selectedValue = e.target.value;

    if (isMulti) {
      const selectedObjects = options.filter((o) =>
        selectedValue.includes(o.value),
      );
      onChange(selectedObjects);
      setTempSelection(selectedObjects);
    } else {
      const selectedObject = options?.find((o) => o.value === selectedValue);
      onChange(selectedObject || null);
    }
  };

  const getSelectedLabels = (selected) => {
    if (!selected) return [];
    if (Array.isArray(selected)) {
      return options
        .filter((o) => selected.includes(o.value))
        .map((o) => o.label);
    }
    const found = options.find((o) => o.value === selected);
    return found ? [found.label] : [];
  };

  // const handleMenuOpen = (e) => {
  //   console.log("anchor = ",e.currentTarget);
    
  //   if (enhancedMenu) {
  //     setAnchorEl(e.currentTarget);
  //     setMenuOpen(true);
  //     setTempSelection(isMulti ? value || [] : value ? [value] : []);
  //   }
  // };
  const handleMenuOpen = (event) => {
    if (enhancedMenu) {
      setAnchorEl(event.currentTarget);
      setMenuOpen(true);

      setTempSelection(
        isMulti
          ? Array.isArray(value)
            ? value
            : []
          : value
            ? [value]
            : []
      );
    }
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
    setAnchorEl(null);
    if (onClose) onClose();
  };

  const handleClearAll = () => {
    setTempSelection([]);
    if (tempSelection.length > 0) {
      handleClearAllFilter([]);
    }
  };

  const handleApply = () => {
    if (isMulti) {
      onChange(tempSelection);
    } else {
      onChange(tempSelection[0] || null);
    }
    handleMenuClose();
  };

  const handleClearAllFilter = (tempSelection) => {
    if (isMulti) {
      onChange(tempSelection);
    } else {
      onChange(tempSelection[0] || null);
    }
    handleMenuClose();
  }


  const handleTempSelectionChange = (opt) => {
    if (isMulti) {
      // const tempValues = tempSelection.map((t) => t.value);
      const tempValues = (Array.isArray(tempSelection)
  ? tempSelection
  : tempSelection
    ? [tempSelection]
    : []
).map((t) => t.value);
      if (tempValues.includes(opt.value)) {
        // const newTempSelection = tempSelection.filter(
        //   (t) => t.value !== opt.value,
        // );
        const newTempSelection = (
  Array.isArray(tempSelection)
    ? tempSelection
    : tempSelection
      ? [tempSelection]
      : []
).filter((t) => t.value !== opt.value);
        setTempSelection(newTempSelection);
      } else {
        const safeTempSelection = Array.isArray(tempSelection)
  ? tempSelection
  : tempSelection
    ? [tempSelection]
    : [];
        // setTempSelection([...tempSelection, opt]);
        setTempSelection([...safeTempSelection, opt]);

      }
    } else {
      // Single select: replace selection
      setTempSelection([opt]);
    }
  };

  useEffect(() => {
    if (selectRef.current) {
      setMenuWidth(selectRef.current.offsetWidth || 200);
      // setMenuWidth(280)
    }
  }, []);

  // Sync tempSelection with value prop to prefill the display
  useEffect(() => {
    setTempSelection(
      isMulti
        ? Array.isArray(value)
          ? value
          : []
        : value
          ? [value]
          : []
    );
  }, [value, isMulti]);

  // Enhanced Custom Menu
  if (enhancedMenu) {
    // const tempSelectedValues = tempSelection.map((t) => t.value);
    const tempSelectedValues = Array.isArray(tempSelection)
  ? tempSelection.map((t) => t.value)
  : [];

    return (
      <>
        <FormControl  fullWidth ref={selectRef}
  sx={{
    width: {
      xs: "100%",
      md: width || "150px",
    },
  }}>
          <Select
            multiple={isMulti}
            displayEmpty
            ref={selectRef}
            value={selectedValues}
            onChange={handleChange}
            // onOpen={handleMenuOpen}
             onClick={handleMenuOpen}
            onClose={handleMenuClose}
            open={false}
            input={<OutlinedInput />}
            IconComponent={KeyboardArrowDownIcon}
            sx={{
              height: "30px",
              "& .MuiSelect-icon": {
                color: "#26252F",
                fontSize: "20px",
                borderRadius: "8px",
              },
              "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                gap: 1,
                fontSize: "12px",
                borderRadius: "8px",

              },
              "& em": {
                color: "#26252F",
                // fontStyle: "normal",
                // opacity: 0.7,
                fontSize: "12px",
              },
              "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
            }}
            renderValue={(selected) => {
              // const tempLabels = tempSelection.map((t) => t.label);
              // const joined = tempLabels.join(", ");
              const safeTempSelection = Array.isArray(tempSelection)
                ? tempSelection
                : tempSelection
                  ? [tempSelection]
                  : [];

              const tempLabels = safeTempSelection.map((t) => t.label);
              const joined = tempLabels.join(", ");

              return (
                <Box
                  component="span"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    maxWidth: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    verticalAlign: "middle",
                    fontSize: "12px",
                  }}
                  title={joined}
                >
                  {tempSelection.length > 0 && isMulti &&(
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: "18px",
                        height: "18px",
                        borderRadius: "50%",
                        backgroundColor: "#1F1C57",
                        color: "white",
                        fontSize: "11px",
                        fontWeight: "bold",
                        flexShrink: 0,
                      }}
                    >
                      {tempSelection.length}
                    </Box>
                  )}
                  <span
                    style={{
                      color: "#26252F",
                      // fontStyle: joined.length ? "Poins" : "italic",
                      // opacity: joined.length ? 1 : 0.7,
                    }}
                  >
                    {joined.length ? joined : placeholder}
                  </span>
                </Box>
              );
            }}
          />
        </FormControl>

        <Menu
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              p: 1,
              backgroundColor: "#fff",
              borderRadius: "8px",
              width: menuWidth || "200px",
              boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.2)",
            },
          }}
        >
          <Box sx={{ maxHeight: "200px", overflowY: "auto", mb: 1 }}>
            {options.length > 0 ? (
              options.map((opt) => (
                <Box
                  key={opt.value}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    p: "8px",
                    cursor: "pointer",
                    borderRadius: "4px",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                  onClick={() => handleTempSelectionChange(opt)}
                >
                  <Checkbox
                    checked={tempSelectedValues.includes(opt.value)}
                    disabled={
                      !isMulti &&
                      tempSelectedValues.length > 0 &&
                      !tempSelectedValues.includes(opt.value)
                    }
                    size="small"
                    sx={{
                      padding: "0px",
                      marginRight: "4px",
                      "&.Mui-checked": {
                        color: "#1F1C57",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: 14,
                      },
                    }}
                  />
                  <span style={{ fontSize: "12px" }}>{opt.label}</span>
                </Box>
              ))
            ) : (
              <Box
                sx={{
                  p: 2,
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#999",
                }}
              >
                No options available
              </Box>
            )}
          </Box>

          <Divider sx={{ my: 1 }} />
          <Box sx={{ display: "flex", gap: 1, justifyContent: "space-between" }}>
            <Button
              size="small"
              variant="outlined"
              onClick={handleClearAll}
              sx={{
                fontSize: "11px",
                textTransform: "none",
                borderColor: "#ccc",
                color: "#333",
                padding: "4px 8px",
              }}
            >
              Clear All
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={handleApply}
              disabled={tempSelectedValues.length === 0}
              sx={{
                fontSize: "11px",
                textTransform: "none",
                backgroundColor: "#EF5713",
                padding: "4px 8px",
                "&:disabled": {
                  backgroundColor: "#e0e0e0",
                  color: "#999",
                },
              }}
            >
              Apply
            </Button>
          </Box>
        </Menu>
      </>
    );
  }

  // Original behavior for non-enhanced or single-select
  return (
    <FormControl sx={{ width }} ref={selectRef}>
      <Select
        multiple={isMulti}
        displayEmpty
        ref={selectRef}
        value={selectedValues}
        onChange={handleChange}
        onClose={onClose}
        onClick={handleMenuOpen}
        // input={<OutlinedInput />}
        IconComponent={KeyboardArrowDownIcon}
        sx={{
          height: "30px",
          "& .MuiSelect-icon": {
            color: "#26252F",
            fontSize: "20px",
          },
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            gap: 1,
            fontSize: "12px",
          },
          "& em": {
            color: "#26252F",
            // fontStyle: "normal",
            // opacity: 0.7,
            fontSize: "12px",
          },
          "&:hover": {
                        backgroundColor: "#e74a4a",
                      },
        }}
        renderValue={(selected) => {
          const labels = getSelectedLabels(selected);
          const joined = labels.join(", ");

          return (
            <Box
              component="span"
              sx={{
                display: "inline-block",
                maxWidth: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                verticalAlign: "middle",
                fontSize: "12px",
              }}
              title={joined}
            >
              {joined.length ? joined : <em>{placeholder}</em>}
            </Box>
          );
        }}
        MenuProps={MenuProps}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {isMulti && (
              <Checkbox
                checked={selectedValues.includes(opt.value)}
                size="small"
                // sx={{
                //   padding: "0px",
                //   marginRight: "4px",
                //   "& .MuiSvgIcon-root": {
                //     fontSize: 14,
                //   },
                // }}
                sx={{
                  padding: "0px",
                  marginRight: "4px",
                  "&.Mui-checked": {
                    color: "#1F1C57",
                  },
                  "& .MuiSvgIcon-root": {
                    fontSize: 14,
                  },
                }}
              />
            )}
            <ListItemText primary={opt.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
